import { useEffect, useRef, useState } from "react";

// Image that fades in over a soft linen placeholder instead of popping in.
// Handles already-cached images via img.complete on mount.
export default function FadeImg({ className = "", alt = "", loading = "lazy", fetchPriority, ...rest }) {
  const ref = useRef(null);
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (ref.current?.complete && ref.current.naturalWidth > 0) setOk(true);
  }, []);
  return (
    <img
      ref={ref}
      alt={alt}
      decoding="async"
      loading={loading}
      fetchPriority={fetchPriority}
      onLoad={() => setOk(true)}
      className={`${className} bg-linen transition-opacity duration-700 ${ok ? "opacity-100" : "opacity-0"}`}
      {...rest}
    />
  );
}
